import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { WindowType } from '../../../../util';
import { Board } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

declare var window: WindowType;

@Component({ name: 'LockdownModal' })
export default class LockdownModal extends Vue {
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    board!: Board;

    private lockdownDelaySeconds: number = 0;

    public open(): void {
        this.lockdownDelaySeconds = 0;
        $(this.$refs.modal!).modal('show');
    }

    public dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private save(): void {
        this.$emit('save', { board: this.board, seconds: this.lockdownDelaySeconds });
        this.dismiss();
    }

    private get lockdownDelayDays(): number {
        return this.lockdownDelaySeconds / 86400;
    }

    private set lockdownDelayDays(val: number) {
        this.lockdownDelaySeconds = val * 86400;
    }
}